import React from "react";
import "./Description.css";
import {useLanguage} from "../context/LanguageContext";
const Description = () => {
    const { language, setLanguage } = useLanguage();

    return (
        <div className="description">
            {language === 'en' ? (<h4 className="head">About</h4>): (<h4 className="head_ar">نبذة عامة</h4>)}

            {language === 'en' ? (<p>Identity theft protection: Monitors, detects fraud, and offers alerts and restoration.</p>):
                (<p className="p_ar" >حماية الهوية: تراقب وتكشف الاحتيال وتوفر التنبيهات والاستعادة.</p>)}
        </div>
    );
};

export default Description;
